import styles from '../../styles/Icons/SearchIconBorder.module.less'

const SearchIconBorder = ({ className = '' }) => (
  <div className={`${className} ${styles.icon}`}>
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.09375 0.9375C8.94147 0.9375 11.25 3.24603 11.25 6.09375C11.25 8.94147 8.94147 11.25 6.09375 11.25C3.24603 11.25 0.9375 8.94147 0.9375 6.09375C0.9375 3.24603 3.24603 0.9375 6.09375 0.9375ZM6.09375 1.875C3.7638 1.875 1.875 3.7638 1.875 6.09375C1.875 8.4237 3.7638 10.3125 6.09375 10.3125C8.4237 10.3125 10.3125 8.4237 10.3125 6.09375C10.3125 3.7638 8.4237 1.875 6.09375 1.875Z"
        fill="#0F2137"
      />
      <path
        d="M6.09375 0.9375V1.0875C8.85863 1.0875 11.1 3.32887 11.1 6.09375H11.25H11.4C11.4 3.16319 9.02431 0.7875 6.09375 0.7875V0.9375ZM11.25 6.09375H11.1C11.1 8.85863 8.85863 11.1 6.09375 11.1V11.25V11.4C9.02431 11.4 11.4 9.02431 11.4 6.09375H11.25ZM6.09375 11.25V11.1C3.32887 11.1 1.0875 8.85863 1.0875 6.09375H0.9375H0.7875C0.7875 9.02431 3.16319 11.4 6.09375 11.4V11.25ZM0.9375 6.09375H1.0875C1.0875 3.32887 3.32887 1.0875 6.09375 1.0875V0.9375V0.7875C3.16319 0.7875 0.7875 3.16319 0.7875 6.09375H0.9375ZM6.09375 1.875V1.725C3.68096 1.725 1.725 3.68096 1.725 6.09375H1.875H2.025C2.025 3.84664 3.84664 2.025 6.09375 2.025V1.875ZM1.875 6.09375H1.725C1.725 8.50654 3.68096 10.4625 6.09375 10.4625V10.3125V10.1625C3.84664 10.1625 2.025 8.34086 2.025 6.09375H1.875ZM6.09375 10.3125V10.4625C8.50654 10.4625 10.4625 8.50654 10.4625 6.09375H10.3125H10.1625C10.1625 8.34086 8.34086 10.1625 6.09375 10.1625V10.3125ZM10.3125 6.09375H10.4625C10.4625 3.68096 8.50654 1.725 6.09375 1.725V1.875V2.025C8.34086 2.025 10.1625 3.84664 10.1625 6.09375H10.3125Z"
        fill="black"
      />
      <path
        d="M9.04354 9.04354C9.20626 8.88083 9.45885 8.86275 9.64154 8.9893L9.70646 9.04354L13.9252 13.2623C14.1083 13.4454 14.1083 13.7421 13.9252 13.9252C13.7625 14.0879 13.5099 14.106 13.3272 13.9794L13.2623 13.9252L9.04354 9.70646C8.86049 9.5234 8.86049 9.2266 9.04354 9.04354Z"
        fill="#0F2137"
        stroke="black"
        strokeWidth="0.3"
      />
    </svg>
  </div>
)

export default SearchIconBorder
